import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import WrapperCell from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/Cells/WrapperCell'
import ImportEmployeesModal from 'modules/shift_management/components/ShiftManagement/ImportEmployeesModal'

interface Props {
  contractVersions: ContractVersions
}

const AddEmployeeRow = ({ contractVersions }: Props) => {
  const [isEmployeesModalOpen, setIsEmployeesModalOpen] = React.useState<boolean>(false)

  return (
    <Box>
      <WrapperCell sticky minWidth="s240" noBorder>
        <Box background="grey000White" flexDirection="row" height="full" padding="s8">
          <Box flexDirection="row" alignItems="center" paddingY="s6">
            <Button onClick={() => setIsEmployeesModalOpen(true)} type="secondary" iconName="add">
              {i18n.t('shift_management.import_employees.action')}
            </Button>
          </Box>
        </Box>
      </WrapperCell>

      {isEmployeesModalOpen && (
        <ImportEmployeesModal
          onClose={() => setIsEmployeesModalOpen(false)}
          contractVersions={contractVersions}
        />
      )}
    </Box>
  )
}

export default observer(AddEmployeeRow)
